export const increaseQty = (t) => {
    const i = t.previousElementSibling
    if (!i?.classList.contains('qty')) return

    i.value = (parseInt(i.value, 10) || 0) + 1
    i.dispatchEvent(new Event('input', { bubbles: true }))
}

export const decreaseQty = (t) => {
    const i = t.nextElementSibling
    if (!i?.classList.contains('qty')) return

    const min = parseInt(i.min, 10) || 1
    const val = parseInt(i.value, 10) || min

    if (val > min) {
        i.value = val - 1
        i.dispatchEvent(new Event('input', { bubbles: true }))
    }
}